var React = require('react');

function Wall60px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M58 41H1a1 1 0 0 1-1-1.001v-39a1 1 0 0 1 1-1h37a1 1 0 0 1 1 1v12h10A1 1 0 0 1 50 14v11.999h8a1 1 0 0 1 1 1v13A1 1 0 0 1 58 41zm-37-2h17V27.999H21V39zM2 39h17V27.999H2V39zm0-13.001h9v-11H2v11zM18 2H2v10.999h16V2zm-5 12.999v11h16v-11H13zM37 2H20v10.999h17V2zm11 12.999H31v11h17v-11zm9 13H40V39h17V27.999z","key":1})]);
}

Wall60px.displayName = "Wall60px";

Wall60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59 41"};

module.exports = Wall60px;

Wall60px.default = Wall60px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/wall-60px.svg
// module id = 1229
// module chunks = 0